import React, { useState, useEffect, Fragment, useContext } from 'react';
import jwtDecode from 'jwt-decode';
import { AppContext } from '../AppContext';
import { AppConsts } from '../enums/AppConsts';
import { Actions } from '../enums/ActionEnums';
import Loader from '../components/Common/Loader';

type Props = {
  children: React.ReactNode;
};

interface decoded {
  exp: number;
  id: string;
  username: string;
  roles: string[];
}

const Auth: React.FunctionComponent<Props> = (props) => {
  const [waitAuthCheck, setWaitAuthCheck] = useState(true);
  const { dispatch } = useContext(AppContext);
  useEffect(() => {
    const token = localStorage.getItem(AppConsts.AccessToken);
    if (!token) {
      // context remove user
      dispatch({ type: Actions.RemoveUser });
    } else {
      const decoded: decoded = jwtDecode(token);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      const { role } = decoded;
      const now = new Date().getTime() / 1000;
      if (decoded.exp < now) {
        // if is not valid -> context remove user
        localStorage.removeItem(AppConsts.AccessToken);
        dispatch({ type: Actions.RemoveUser });
      } else {
        const roles = [] as string[];
        if (role) {
          if (typeof role === 'string' || role instanceof String) {
            roles.push(role as string);
          } else {
            (role as string[]).map((r) => roles.push(r));
          }
        }
        dispatch({
          type: Actions.SetUser,
          payload: {
            data: {
              id: decoded.id,
              username: decoded.username,
              roles: decoded.roles,
              first_name: '',
              last_name: '',
              password: ''
            },
            token
          }
        });
      }
    }
    setWaitAuthCheck(false);
  }, []);

  return waitAuthCheck ? <Loader loading={waitAuthCheck} /> : <Fragment>{props.children}</Fragment>;
};
export default Auth;
